import { gql } from "@apollo/client";

export const GET_USER = gql`
  query GetUser($user_id: Int!) {
    Web {
      getUser(user_id: $user_id) {
        user_id
        phone
        name
        img
        about
        create_time
        verified
        status
        ability
        type
        paid
        fee
        role
        ae
        pe
        le
        ue
        user_type
        favs
        review
        manager_id
        manager_paid
        listings
        crm
        last_seen
        can_boost
        iam_verified
      }
    }
  }
`;
export const GET_USER_WITH_REVIEWS = gql`
  query GetUser($user_id: Int!) {
    User {
      get(user_id: $user_id) {
        user_id
        phone
        name
        img
        about
        create_time
        verified
        status
        ability
        type
        paid
        fee
        role
        ae
        pe
        le
        ue
        user_type
        favs
        review
        manager_id
        manager_paid
        listings
        crm
        last_seen
        can_boost
        iam_verified
        office_location {
          lat
          lng
        }
      }
      reviews(user_id: $user_id) {
        total
      }
    }
  }
`;

export const GET_OWNER_LISTINGS = gql`
  query GetOwnerListings($limit: Int, $offset: Int) {
    Listing {
      getMyListings(limit: $limit, offset: $offset) {
        listings {
          id
          title
          create_time
          last_update
          refresh
          category
          has_img
          special
          imgs
          imgs_desc
          status
          support_imgs
          support_imgs_desc
          premium
          price
          wc
          meter_price
          age
          area
          fl
          rent_period
          beds
          ketchen
          livings
          men_place
          women_place
          apts
          stores
          duplex
          furnished
          driver
          maid
          basement
          lift
          pool
          stairs
          fb
          vb
          tent
          rooms
          wells
          trees
          backyard
          playground
          family
          family_section
          street_direction
          street_width
          type
          car_entrance
          ac
          location {
            lat
            lng
          }
          boosted
          address
          content
          uri
          city_id
          direction_id
          district_id
          province_id
          views
          user_id
          user_type
          extra_unit
          verified
          has_video
          employee_user_id
          mgr_user_id
          capacity
          phone_1
          phone_2
          assigned_to
          approved
          gh_id
          building_no
          unique_listing
          structure
          appraisal_id
          virtual_tour_link
          accurate_location
          plan_no
          parcel_no
          show_parcel_info
          project_id
        }
        total
      }
    }
  }
`;

export const GET_EXPIRED_LISTING = gql`
  query GetExpiredListing($from: Int, $size: Int) {
    User {
      expiredListings(from: $from, size: $size) {
        total
        listings {
          id
          category
          imgs
          imgs_desc
          videos {
            video
            thumbnail
          }
          verified
          gh_id
          appraisal_id
          address
          city_id
          location {
            lat
            lng
          }
          premium
          status
          create_time
          refresh
          boosted
          unique_listing
          virtual_tour_link
          user {
            img
            name
            type
            paid
            fee
            iam_verified
            review
          }
          user_id
          employee {
            img
            name
          }
          employee_user_id
          stc_coverage {
            fifth_generation
            fourth_generation
            fiber
          }
          map_premium_services {
            logo
            name
            distance_in_km
          }
          ac
          age
          apts
          backyard
          basement
          beds
          type
          car_entrance
          content
          driver
          duplex
          extra_unit
          family
          family_section
          fb
          fl
          furnished
          ketchen
          lift
          livings
          maid
          meter_price
          playground
          pool
          price
          rent_period
          rooms
          area
          stairs
          stores
          street_direction
          street_width
          tent
          trees
          vb
          wc
          wells
        }
      }
    }
  }
`;

export const GET_USER_FEES = gql`
  query GetUserRecurringFees($offset: Int) {
    User {
      getRecurringFees(offset: $offset) {
        total
        list {
          payment_time
          content
          payment_id
          paid_via
        }
      }
    }
  }
`;

export const GET_USER_USAGE = gql`
  query {
    Offices {
      Package {
        usage {
          mgr_user_id
          pkg_name
          start_time
          expire_time
          transaction_id
        }
      }
    }
  }
`;

export const GET_AUTH_USER = gql`
  query {
    User {
      get {
        user_id
        has_daily_rentable
        phone
        name
        img
        about
        chosen_user_type
        listings
        favs
        type
        paid
        rega_approved
        iam_verified
        show_aqar_plus
        active_aqar_plus_user
        create_time
      }
    }
  }
`;

export const GET_IAM_STATUS = gql`
  query {
    User {
      getIAMStatus {
        full_name
        id
      }
    }
  }
`;
export const CHECK_BLACK_LIST_BY_IAM_ID = gql`
  query CheckBlackListStatus($iam_id: String!) {
    User {
      checkBlacklistStatusByIamId(iam_id: $iam_id)
    }
  }
`;

export const GET_IAM_URL = gql`
  query GetIamUrl($redirect_url: String, $desired_service: IAM_SERVICES) {
    User {
      getIAMUrl(redirect_url: $redirect_url, desired_service: $desired_service)
    }
  }
`;

export const GET_HTML_AGREEMENT = gql`
  query GetHTMLAgreement($contract_id: Int!) {
    AgentsVerification {
      getHTMLAgreement(contract_id: $contract_id)
    }
  }
`;

export const GET_USER_REVIEWS = gql`
  query GetUserReviews($user_id: Int!) {
    User {
      reviews(user_id: $user_id) {
        total
      }
    }
  }
`;

export const GET_USER_PAYOUTS = gql`
  query GetPayouts($offset: Int, $limit: Int) {
    User {
      getPayouts(offset: $offset, limit: $limit) {
        payouts {
          payout_id
          amount
          paid_at
          status
        }
        total
      }
    }
  }
`;

export const GET_PAYOUT = gql`
  query GetPayout($payout_id: Int!) {
    User {
      getPayout(payout_id: $payout_id) {
        payout_id
        amount
        paid_at
        user {
          user_id
          name
          iban
          iban_bank
        }
        status
        paid_at
        payment_transactions {
          id
          txn_date
          amount
          transaction_type_id
          resource_id
          resource_type
          masked_resource_id
          user {
            user_id
            name
          }
        }
      }
    }
  }
`;

export const FETCH_SYSTEM_MSGS = gql`
  query FetchSystemMsgs(
    $msg_id: String!
    $offset: String
    $time_offset: Float
  ) {
    Chat {
      threads(msg_id: $msg_id, offset: $offset, time_offset: $time_offset) {
        list {
          msg_id
          content
          send_time
        }
        u_id
        offset
      }
    }
  }
`;

export const GET_NEW_MSGS_COUNT = gql`
  {
    Chat {
      msgs {
        list {
          new_msgs
        }
      }
    }
  }
`;
